const selectors = {
  dataGridCurrentImage: 'data-grid-current-image',
};

const classes = {
  active: 'is-active',
};

class ProductGridItemImage extends HTMLElement {
  static get observedAttributes() {
    return ['loading', selectors.dataGridCurrentImage];
  }

  connectedCallback() {
    if (this.getAttribute(selectors.dataGridCurrentImage) === null) {
      this.hide();
    } else {
      this.show();
    }
  }

  attributeChangedCallback(name, _oldValue, newValue) {
    switch (name) {
      case 'loading':
        if (newValue === null || newValue === 'eager') {
          this.eagerLoad();
        }
        break;
      case selectors.dataGridCurrentImage:
        if (newValue === null) {
          this.hide();
        } else {
          this.show();
        }
        break;
      default:
    }
  }

  show() {
    this.classList.add(classes.active);
  }

  hide() {
    this.classList.remove(classes.active);
  }

  // Ensure that child image has loaded in case the child was wrapped in `<template>` to prevent eager loading
  eagerLoad() {
    const childElement = this.firstElementChild;

    switch (childElement.nodeName) {
      case 'TEMPLATE':
        // For template children, replace the template with the child img tag which will load the image
        const template = childElement;
        const templateContent = template.content;

        // Make sure template children images load immediatley
        templateContent.querySelectorAll('img').forEach((imgEl) => {
          imgEl.setAttribute('loading', 'eager');
          imgEl.setAttribute('fetchpriority', 'high');
        });
        template.replaceWith(templateContent);
        break;
      case 'IMG':
        // For image children, make sure they load immediately if they were otherwise set to lazy load
        childElement.setAttribute('loading', 'eager');
        childElement.setAttribute('fetchpriority', 'high');
        break;
    }
  }
}

export {ProductGridItemImage};
